import React from "react";
import { OMNISCAN_CORPORATE_RED } from "../../../constants/colors";
import { OMNISCAN_CORPORATE_GREEN } from "../../../constants/colors";
import UtilisationAmStripChart from "./UtilisationAmStripChart";
import UtilisationIndicator from "./UtilisationIndicator";
import HeatBand from "./HeatBand";

// --- KPI Panel Wrapper -------------------------------------------------------
export default function KpiPanel({ data }) {

  if (!data || data.length === 0) {
    return (
      <div style={{ padding: "20px", color: "white", opacity: 0.8 }}>
        Loading KPIs...
      </div>
    );
  }

  // --- Convert row into utilisation % ---------------------------------------
  function toUtilPercent(d) {
    if (d.occupiedFlag === 1) return 100;
    if (d.signsOfLifeFlag === 1) return 50;
    return 0;
  }

  // --- Build series ---------------------------------------------------------
  const overallSeries = data.map(d => ({
    value: toUtilPercent(d),
    date: d.observationTs
  }));

  const deskSeries = data
    .filter(d => d.spaceTypeName && d.spaceTypeName.startsWith("A"))
    .map(d => ({
      value: toUtilPercent(d),
      date: d.observationTs
    }));

  const roomSeries = data
    .filter(d => d.spaceTypeName && !d.spaceTypeName.startsWith("A"))
    .map(d => ({
      value: toUtilPercent(d),
      date: d.observationTs
    }));

  // --- Stats calculator ------------------------------------------------------
  function calcCategoryStats(series) {
    if (!series || series.length === 0) {
      return { avg: 0, max: 0, maxDate: "", min: 0, minDate: "", numericSeries: [] };
    }

    const total = series.reduce((acc, p) => acc + p.value, 0);
    const overallAvg = Math.round(total / series.length);

    const groups = {};
    series.forEach(p => {
      if (!groups[p.date]) groups[p.date] = [];
      groups[p.date].push(p.value);
    });

    const timestampAverages = Object.keys(groups).map(ts => {
      const arr = groups[ts];
      const avg = arr.reduce((a, b) => a + b, 0) / arr.length;
      return { ts, avg };
    });

    if (timestampAverages.length === 0) {
      return { avg: overallAvg, max: 0, maxDate: "", min: 0, minDate: "", numericSeries: [] };
    }

    timestampAverages.sort((a, b) => new Date(a.ts) - new Date(b.ts));

    let maxObj = timestampAverages[0];
    let minObj = timestampAverages[0];

    timestampAverages.forEach(pt => {
      if (pt.avg > maxObj.avg) maxObj = pt;
      if (pt.avg < minObj.avg) minObj = pt;
    });

    const numericSeries = timestampAverages.map(pt => Math.round(pt.avg));

    return {
      avg: overallAvg,
      max: Math.round(maxObj.avg),
      maxDate: maxObj.ts,
      min: Math.round(minObj.avg),
      minDate: minObj.ts,
      numericSeries: numericSeries
    };
  }

  // --- Build final KPI stats -------------------------------------------------
  const overallStats = calcCategoryStats(overallSeries);
  const deskStats = calcCategoryStats(deskSeries);
  const roomStats = calcCategoryStats(roomSeries);

  // --- DARK card style --------------------------------------------------------
  const darkCard = {

      display:
          "flex",

      flexDirection:
          "column",

      width:
          "100%",

      padding:
          "15px 0 10px 0",

      marginBottom:
          "22px",

      borderRadius:
          "0px",

      border:
          "1px solid rgba(255,255,255,0.07)",

      borderBottom:
          "1px solid rgba(255,255,255,0.10)"

  };

  return (
    <div
      style={{
        width: "100%",
        padding: 0,
        boxSizing: "border-box",
        flexDirection: "column",
        display: "flex",
        color: "white",
		height:'800px',
		overflow:'hidden'
      }}
    >
      {/* TOP KPI CARD ------------------------------------------------------- */}
      <div style={darkCard}>
        <UtilisationIndicator
          title="Overall Utilisation"
          percentage={overallStats.avg}
          maxValue={overallStats.max}
          maxDate={overallStats.maxDate}
          minValue={overallStats.min}
          minDate={overallStats.minDate}
          darkMode={true}
        />

        <UtilisationIndicator
          title="Desk Utilisation"
          percentage={deskStats.avg}
          maxValue={deskStats.max}
          maxDate={deskStats.maxDate}
          minValue={deskStats.min}
          minDate={deskStats.minDate}
          darkMode={true}
        />

        <UtilisationIndicator
          title="Meeting Room Utilisation"
          percentage={roomStats.avg}
          maxValue={roomStats.max}
          maxDate={roomStats.maxDate}
          minValue={roomStats.min}
          minDate={roomStats.minDate}
          darkMode={true}
        />
      </div>

      {/* STRIP CHART + HEATBAND CARD --------------------------------------- */}
      <div style={darkCard}>
        <div style={{ width: "calc(100% - 40px)", marginLeft: "20px", marginTop: "-10px" }}>
          <div style={{ minHeight: 100, overflow: "hidden", marginTop:'-40px' }}>
            <UtilisationAmStripChart data={overallStats.numericSeries} darkMode={true} />
          </div>

          <div style={{ marginTop: 5, marginBottom: 40 }}>
            <HeatBand data={overallStats.numericSeries} darkMode={true} />
          </div>
        </div>
      </div>
    </div>
  );
}
